"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getXsrfHeader = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var getXsrfHeader = exports.getXsrfHeader = function getXsrfHeader() {
  var xsrfCookie = _jsCookie.default.get('XSRF-TOKEN');
  return xsrfCookie ? {
    'x-xsrf-token': xsrfCookie
  } : {};
};
//# sourceMappingURL=getXsrfHeader.js.map